import React from 'react';
import { Model3DXML } from '@gkn-ili/cad-model';
import { Canvas } from '@react-three/fiber';
import App3DXML3DReference from './3DXMLReference';
import { ThreeEffects } from '../../../utils/threeEffects';
import App3DCamera from './camera';
import { Button, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { useView3DCamera } from '../../../context/context3D';
import { Home16Regular, ZoomFit16Regular } from '@fluentui/react-icons';
import { ContentModel } from '@gkn-ili/views/dist/PageContent';
import App3DAnnotationOverlay from './annotationOverlay';

const useStyles = makeStyles({
  root: {
    flex: '1px 1 1',
    display: 'grid',
    gridTemplateColumns: 'auto',
    gridTemplateRows: 'auto',
    width: '100%',
    height: '100%',
  },
  canvas: {
    backgroundColor: '#ffffff',
    ...shorthands.gridArea(1, 1, 2, 2),
  },
  canvasOverlay: {
    ...shorthands.gridArea(1, 1, 2, 2),
    zIndex: 1,
    userSelect: 'none',
    pointerEvents: 'none',
    position: 'relative',
  },
  canvasButtonContainer: {
    padding: tokens.spacingHorizontalM,
    position: 'absolute',
    bottom: 0,
    left: 0,
    pointerEvents: 'auto',
  },
  canvasButton: {
    display: 'inline-block',
  },
});

export default function AppPageView3D(
  props: React.PropsWithRef<{
    model: Model3DXML;
    view: ContentModel['content']['view'];
  }>,
): JSX.Element {
  const styles = useStyles();

  const camera = useView3DCamera();

  return (
    <div className={styles.root}>
      <Canvas className={styles.canvas}>
        <directionalLight position={[0, 1, 0]} intensity={1} />
        <ambientLight intensity={2} />
        <App3DXML3DReference reference3D={props.model} path={[props.model.name]} />

        <ThreeEffects />
        <App3DCamera view={props.view} />
      </Canvas>
      <div className={mergeClasses(styles.canvasOverlay)}>
        <div className={styles.canvasButtonContainer}>
          <Button
            appearance="subtle"
            className={styles.canvasButton}
            icon={<Home16Regular />}
            onClick={() => {
              camera.goHome();
            }}
          />
          <Button
            appearance="subtle"
            className={styles.canvasButton}
            icon={<ZoomFit16Regular />}
            onClick={() => {
              camera.zoomFit();
            }}
          />
        </div>
      </div>
      <App3DAnnotationOverlay className={styles.canvasOverlay} />
    </div>
  );
}
